import { render, staticRenderFns } from "./TradingAccount.vue?vue&type=template&id=94098968&scoped=true&"
import script from "./TradingAccount.vue?vue&type=script&lang=js&"
export * from "./TradingAccount.vue?vue&type=script&lang=js&"
import style0 from "./TradingAccount.vue?vue&type=style&index=0&id=94098968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94098968",
  null
  
)

export default component.exports